import { getDocs, collection, query, where } from "@firebase/firestore";
import { hideLoading, setForRentSetsList, showLoading } from "./for-rent-sets-list-slice";
import { showErrorSnackbar } from "../../../../shared/snackbar/snackbar-slice";

export const getForRentSetsService = async (dispatch, db, coll) => {
    try {
        dispatch(showLoading());
        const querySnapshot = await getDocs(
            query(collection(db, coll), where("type", "==", "For rent"), where("category", "==", "Set"))
        );
        const data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        dispatch(setForRentSetsList(data));
        dispatch(hideLoading());
    } catch (e) {
        dispatch(showErrorSnackbar('Fetch failed! Please try again.'))
        console.error("ForRentSetsList getForRentSetsService error: ", e);
    }
};